import React from 'react';
import { func } from 'prop-types';
import { reduxForm } from 'redux-form';
import { scrollToInvalid } from '@widergy/web-utils/lib/form';
import { handleKeyDown } from '@widergy/utilitygo-forms-web/dist/utils/formUtils';
import { WithLoading } from '@widergy/energy-ui';

import UTForm from 'app/components/UTForm';
import { ACCOUNT_RELATIONSHIP_VALIDATION } from 'constants/reduxForms';
import { questionsPropTypes } from 'types/accountTypes';

import styles from './styles';

const AccountRelationshipValidation = ({ handleSubmit, questions }) => (
  <form onSubmit={handleSubmit} onKeyDown={handleKeyDown(handleSubmit)} style={styles.form} noValidate>
    <UTForm fields={questions} />
  </form>
);

AccountRelationshipValidation.propTypes = {
  handleSubmit: func.isRequired,
  questions: questionsPropTypes
};

export default WithLoading(props => props.loading)(
  reduxForm({ form: ACCOUNT_RELATIONSHIP_VALIDATION, onSubmitFail: errors => scrollToInvalid(errors) })(
    AccountRelationshipValidation
  )
);
